export default "__VITE_ASSET__CQYTLdLk__"